import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext.js';
import Dashboard from './components/Dashboard.js';
import Login from './components/Login.js';
import './App.css';
import './styles/filters.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="App">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          fontSize: '1.2rem',
          color: '#666'
        }}>
          Carregando...
        </div>
      </div>
    );
  }

  return user ? children : <Navigate to="/" replace />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="App">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          fontSize: '1.2rem',
          color: '#666'
        }}>
          Carregando...
        </div>
      </div>
    );
  }

  return !user ? children : <Navigate to="/dashboard" replace />;
}

function AppContent() {
  const { user, logout } = useAuth();

  return (
    <div className="App">
      <Routes>
        <Route 
          path="/" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />
        <Route 
          path="/dashboard" 
          element={
            <PrivateRoute>
              <Dashboard user={user} onLogout={logout} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/users" 
          element={
            <PrivateRoute>
              <Dashboard user={user} onLogout={logout} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/entities" 
          element={
            <PrivateRoute>
              <Dashboard user={user} onLogout={logout} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/pets" 
          element={
            <PrivateRoute>
              <Dashboard user={user} onLogout={logout} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/schedules" 
          element={
            <PrivateRoute>
              <Dashboard user={user} onLogout={logout} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/plans" 
          element={
            <PrivateRoute>
              <Dashboard user={user} onLogout={logout} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/reviews" 
          element={
            <PrivateRoute>
              <Dashboard user={user} onLogout={logout} />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/reports" 
          element={
            <PrivateRoute>
              <Dashboard user={user} onLogout={logout} />
            </PrivateRoute>
          } 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="bottom-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#fff',
              color: '#333',
              fontSize: '14px',
              fontWeight: '500',
              borderRadius: '10px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              padding: '16px',
            },
            success: {
              iconTheme: {
                primary: '#10B981',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#EF4444',
                secondary: '#fff',
              },
            },
          }}
        />
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
